import {AppConfigService} from '../services/appConfig.service';
import {resolveLocale} from '../../common/common';

export const getLocale = (appConfigService: AppConfigService): string => {
  return resolveLocale(appConfigService.getAppConfig());
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/config/locale.config.ts